import type { FC } from 'react';
import { useParams } from 'react-router';

import Page from '@zen/Components/Page';
import RouteTabs from '@zen/Components/RouteTabs';
import SkeletonTableLoading from '@zen/Components/SkeletonTableLoading';

import useShipmentListScope from '../../hooks/useShipmentListScope';
import { getShipmentListRouteTabsConfig, getShipmentListTabSlug } from '../../routingHelpers';
import { getTableId, getTableTitle, shipmentListColumns } from '../../shipmentListTableConfiguration';
import { DEFAULT_SHIPMENT_LIST_TAB, shipmentListTabs } from '../../shipmentListTabs';
import type { ShipmentListTabConfig, ShipmentListTabDefinition } from '../../types';
import ShipmentScopes from '../ShipmentScopes';

const skeletonTabsConfiguration: ShipmentListTabConfig[] = shipmentListTabs.map(
  (definition: ShipmentListTabDefinition): ShipmentListTabConfig => ({ ...definition, component: null })
);

const ShipmentListSkeleton: FC = () => {
  const { tab: tabSlug }: { tab?: string } = useParams<{ tab?: string }>();
  const { activeScope, setActiveScope } = useShipmentListScope();
  const isAllShipmentsTab: boolean = !tabSlug || tabSlug === getShipmentListTabSlug(DEFAULT_SHIPMENT_LIST_TAB);

  return (
    <Page tabsComponent={<RouteTabs tabsConfig={getShipmentListRouteTabsConfig(skeletonTabsConfiguration)} />} title="Shipments">
      {isAllShipmentsTab && (
        <div data-component="shipment-list-skeleton">
          <ShipmentScopes activeScope={activeScope} isLoading={true} kpiCounts={undefined} onScopeChange={setActiveScope} />
          <div className="mt-4">
            <SkeletonTableLoading
              columns={shipmentListColumns}
              tableId={getTableId(activeScope)}
              title={getTableTitle(activeScope)}
            />
          </div>
        </div>
      )}
    </Page>
  );
};

export default ShipmentListSkeleton;
